@if (profileField$ | async; as profileField) {
  @if (thesaurusField) {
    <med-form-thesaurus
      [id]="profileField.FieldDefinition.FlatKey"
      [control]="control$ | async"
      [helpText]="profileField.Description"
      [label]="profileField.DisplayLabel ? profileField.DisplayLabel : profileField.FieldDefinition.Label"
      [labelIcons]="labelIcons"
      [thesaurusDefDottedKey]="thesaurusField.DottedKey"
      [recordIds]="thesaurusFragmentIds"
      [multiple]="multiple"
      [enableSuggestions]="submitSuggestionFunction$ | async"
      [selectValuesLabel]="'thesaurus.thesaurus-input.consult-structure' | translate"
      [indeterminateMsg]="'general.only-matching-values-shown' | translate"
      [maxValuesMsg]="'thesaurus.thesaurus-input.max-values-reached' | translate"
      [errorMsg]="'form.error.required-field' | translate"
      [suggestionExistsErrorMsg]="'thesaurus.error.concept-exists' | translate"
      [disabledMsg]="disabledMessageKey | translate"
      [canBeIndeterminate]="multiple"
      [initialSuggestions]="initialSuggestions"
      [activeRecord]="activeRecord"
      >
      <div slot="inputPrefix">
        <ng-content></ng-content>
      </div>
    </med-form-thesaurus>
  }
}
